import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M15.023 10v1.75a3.179 3.179 0 0 1-3.32 3h-6.86a3.179 3.179 0 0 1-3.32-3V10a.75.75 0 0 1 1.5 0v1.75a1.686 1.686 0 0 0 1.82 1.5H11.7a1.693 1.693 0 0 0 1.82-1.5V10a.75.75 0 1 1 1.5 0Zm-7.55.84a.748.748 0 0 0 1.06 0l3.55-3.55a.75.75 0 1 0-1.06-1.06L8.753 8.5V2a.75.75 0 0 0-1.5 0v6.5l-2.27-2.27a.754.754 0 0 0-1.06 0 .737.737 0 0 0 0 1.06Z';
const draw24px =
  'M16.08,12.3l-3.55,3.55a.78.78,0,0,1-.24.16.72.72,0,0,1-.29.06.76.76,0,0,1-.53-.22L7.92,12.3A.75.75,0,1,1,9,11.24l2.27,2.27V4a.75.75,0,0,1,1.5,0v9.51L15,11.24a.74.74,0,0,1,1.06,0A.75.75,0,0,1,16.08,12.3ZM12,16.07a.76.76,0,0,1-.53-.22A.71.71,0,0,0,12,16.07ZM19.75,16V14a.75.75,0,0,0-1.5,0v2A2.25,2.25,0,0,1,16,18.25H8A2.25,2.25,0,0,1,5.75,16V14a.75.75,0,0,0-1.5,0v2A3.75,3.75,0,0,0,8,19.75h8A3.75,3.75,0,0,0,19.75,16Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const DownloadIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'download'),
) as IconWithRender;

DownloadIcon.displayName = 'DownloadIcon';
DownloadIcon.propTypes = Icon.propTypes;
DownloadIcon.renderIcon = (props) => <DownloadIcon {...props} />;
export default DownloadIcon;
